<template>
  <div>
    <!-- Filters -->
    <div class="card">
      <div class="card-body">
        <form>
          <h5 class="card-title">Filtres</h5>
          <div class="row">
            <div class="col-xs-3" style="margin: 10px;">
              <fieldset>
                <label><strong>RLISS</strong></label>
                <select class="browser-default custom-select"
                        v-model="f_rliss">
                  <option value="0">Tous les RLISS...</option>
                  <option v-for="rl in rlissOptions" :key="rl.rliss_id"
                          :value="rl.rliss_id" v-text="rl.rliss_fr">
                  </option>
                </select>
              </fieldset>
            </div>
            <div class="col-xs-3" style="margin: 10px;">
              <fieldset>
                <label><strong>Statut des fournisseurs</strong></label>
                <div class="checkbox">
                  <label>
                    <input type="checkbox" value="1" checked
                           v-model="f_status"
                           v-on:change="refresh">
                    Identifié
                  </label>
                </div>
                <div class="checkbox">
                  <label>
                    <input type="checkbox" value="2" checked
                           v-model="f_status"
                           v-on:change="refresh">
                    Désigné partiel
                  </label>
                </div>
                <div class="checkbox">
                  <label>
                    <input type="checkbox" value="3" checked
                           v-model="f_status"
                           v-on:change="refresh">
                    Désigné complet
                  </label>
                </div>
              </fieldset>
            </div>
            <div class="col-xs-3" style="margin: 10px;">
              <fieldset>
                <label><strong>Période</strong></label>
                <select class="form-control browser-default custom-select"
                        v-model="f_period">
                  <option v-for="(p, i) in periodOptions"
                          :key="i"
                          :value="p"
                          v-text="p">
                  </option>
                </select>
              </fieldset>
            </div>
            <div class="col-xs-3" style="margin: 10px;">
              <fieldset>
                <label><strong>Inclure les postes</strong></label>
                <div class="radio">
                  <label>
                    <input type="radio" id="filterPositions1" value="requiredOnly" checked
                           v-model="f_positions"
                           v-on:change="refresh">
                    Postes francophones requis seulement
                  </label>
                </div>
                <div class="radio">
                  <label>
                    <input type="radio" id="filterPositions2" value="all"
                           v-model="f_positions"
                           v-on:change="refresh">
                    Tous les postes
                  </label>
                </div>
              </fieldset>
            </div>
            <div class="col-xs-3"></div>
          </div>
        </form>
      </div>
    </div>

    <!-- Ratios -->
    <table class="table table-sm table-bordered">
      <thead>
      <tr style="background-color: #f0f8ff">
        <th colspan="2" style="width: 400px;"></th>
        <th colspan="2">Population</th>
        <OnRatiosTableHeaders1 />
      </tr>
      <tr style="background-color: #f0f8ff">
        <th>Fournisseur</th>
        <th>RLISS</th>
        <th>% Pop.<br/>franco.</th>
        <th>% Clients<br/>franco.</th>
        <OnRatiosTableHeaders2 />
      </tr>
      </thead>
      <tbody>
      <tr v-for="(r, i) in filteredByRliss" :key="i">
        <td>
          <a :href="agencyUrl(r)" @click="agencyUrlClick(r)">{{r.agency_fr}}</a>
        </td>
        <td>{{r.rliss_fr}}</td>
        <td>{{r.total_percentage_francophone}}</td>
        <td>{{percentClientFr(r)}}</td>
        <OnRatiosTableCells :row="r" />
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import OnRatiosTableHeaders1 from "@/components/OnRatiosTableHeaders1";
import OnRatiosTableHeaders2 from '@/components/OnRatiosTableHeaders2';
import OnRatiosTableCells from "@/components/OnRatiosTableCells";
import axios from 'axios';

function lastYearPeriod() {
  const year = new Date().getFullYear();
  return (year - 2).toString() + '-' + (year - 1).toString();
}

export default {
  name: 'OnRatiosEmplois',
  components: {
    OnRatiosTableHeaders1,
    OnRatiosTableHeaders2,
    OnRatiosTableCells
  },
  data() { return {
    f_rliss: 0,
    f_period: lastYearPeriod(),
    f_positions: 'requiredOnly',
    f_status: ["1", "2", "3"],
    ratios: []
  }},
  computed: {
    rlissOptions() {
      // Set of RLISS
      let result = [];
      for (let i = 0; i < this.ratios.length; i++) {
        let found = false;
        for (let j = 0; j < result.length; j++ ) {
          if (result[j].rliss_id === this.ratios[i].rliss_id) {
            found = true;
            break;
          }
        }

        if (!found) {
          result.push({
            rliss_id : this.ratios[i].rliss_id,
            rliss_fr : this.ratios[i].rliss_fr
          });
        }
      }

      // Sort
      result.sort( function(a, b){
        return a.rliss_fr.localeCompare(b.rliss_fr);
      });

      return result;
    },
    filteredByRliss() {
      return this.ratios.filter(r =>
          this.f_rliss == 0 || r.rliss_id === this.f_rliss
      )
    },
    periodOptions() {
      const result = [];
      const year = new Date().getFullYear();
      for (let i = 2017; i <= year; i++) {
        result.push(
            i.toString() + '-' + (i+1).toString()
        );
      }

      result.reverse();
      return result;
    }
  },
  watch: {
    f_period() {
      this.refresh();
    }
  },
  methods: {
    agencyUrl(r) {
      return '/on/ratiosemplois/' + r.agency_id;
    },
    agencyUrlClick(r) {
      this.$router.push(this.agencyUrl(r));
      return false;
    },
    percentClientFr(r) {
      return r.client_french_percent || r.client_french_visits_percent;
    },
    refresh() {
      axios
          .get(
              this.$root.$data.server_base + '/api/on/ratios_emplois_rliss.php',
              {
                params: {
                  period: this.f_period,
                  positions: this.f_positions,
                  status: this.f_status
                }
              }
          ).then(rsp => {
            this.ratios = rsp.data.ratios;
          });
    }
  },
  mounted() {
    this.refresh();
  }
}

</script>